import { z } from 'zod';

import { treatmentApproachesSchema } from '@nesso/session-contracts/session.models';
import {
    sessionNoteGenerate,
    sessionNoteSetFeedback,
    sessionNoteUpdate,
    sessionNoteWriteBaseSchema,
} from '@nesso/session-contracts/session-note.commands';
import { sessionNoteContentSchema } from '@nesso/session-contracts/session-note.models';

import { MAX_SELECTED_APPROACHES } from '@/entities/session';

export const generateSessionNoteOutputSchema = sessionNoteGenerate.output;
export const updateSessionNoteOutputSchema = sessionNoteUpdate.output;
export { chiefComplaintSchema } from '@nesso/session-contracts/nesso-note/chief-complaint';
export { clientPresentationSchema } from '@nesso/session-contracts/nesso-note/client-presentation';
export {
    interventionsSchema,
    treatmentApproachSchema,
} from '@nesso/session-contracts/nesso-note/interventions';
export {
    nextSessionSchema,
    planSchema,
} from '@nesso/session-contracts/nesso-note/plan';
export {
    managingSymptomsCategorySchema,
    progressSchema,
} from '@nesso/session-contracts/nesso-note/progress';
export { riskSchema } from '@nesso/session-contracts/nesso-note/risk';
export {
    nessoNoteContentSchema,
    sessionNoteContentSchema,
    sessionNoteStatusSchema,
    sessionNoteTypeSchema,
    soapNoteContentSchema,
} from '@nesso/session-contracts/session-note.models';
export const SOAP_FIELD_MAX_LENGTH = 5000;

export const generateSessionNoteInputSchema = sessionNoteGenerate.input.omit({
    practiceId: true,
    practiceMemberId: true,
});

export const writeSessionNoteInputSchema = sessionNoteWriteBaseSchema
    .omit({ practiceMemberId: true })
    .and(sessionNoteContentSchema);

export {
    formatSettingsSchema,
    sessionNoteFormatSchema,
    sessionNoteIdentifierSchema,
    sessionNoteLengthSchema,
} from '@nesso/session-contracts/session-note.models';

export const updateSessionNoteInputSchema = sessionNoteUpdate.input.omit({
    practiceMemberId: true,
});

export const setSessionNoteFeedbackInputSchema = sessionNoteSetFeedback.input.omit({
    practiceMemberId: true,
});

export const generateNoteSchema = z.object({
    treatmentApproaches: treatmentApproachesSchema
        .min(1, 'Select at least 1 treatment approach')
        .max(MAX_SELECTED_APPROACHES, `Select up to ${MAX_SELECTED_APPROACHES} approaches`),
});
